import 'bootstrap/dist/css/bootstrap.min.css';
import {motion} from "framer-motion";
import React, {useEffect, useState} from "react";
import {Link} from "react-router-dom";

const ListSSM = () => {
    const [listSimulation, setListSimulation] = useState([]);

    useEffect(() => {
        fetch('/simulations/index.json')
            .then(res => res.json())
            .then(setListSimulation)
            .catch(err => console.error('Errore caricamento index.json:', err));
    }, []);

    return (
        <div className="container my-4">
            <div className="row">
                {listSimulation.map((item, index) => (
                    <motion.div key={index} className="col-md-4 mb-3">
                        <div className="card p-3">
                            <h5>{item.title}</h5>
                            <Link to={`/ssm-simulation/${item.file.replace('simulation_','').replace('.json','')}`} className="btn btn-primary mt-2">
                                Apri simulazione
                            </Link>
                        </div>
                    </motion.div>
                ))}
            </div>
        </div>
    );
}

export default ListSSM;